module.exports = __webpack_public_path__ + "images/d6dabb1c00431bcfe7f438a108ab61e4-logo_color.svg";